import React from "react";
import Link from "helpers/link";

const Breadcrumbs = ({ links }) => {
    const currentPageStyling = (link) => (link?.currentPage ? "text-sm font-medium" : "text-sm font-light");

    return (
        <div>
            <div className="md:flex hidden justify-start align-center mb-2">
                <Link className="text-sm font-light" to="https://sealskincovers.com/">
                    Home
                </Link>
                <p className="mx-2 text-sm">/</p>
                {links?.map((link) => (
                    <React.Fragment key={link._key}>
                        <Link
                            key={link?.url}
                            className={currentPageStyling(link)}
                            to={link?.url}
                            style={link?.currentPage ? { pointerEvents: "none" } : null}
                        >
                            {link?.title}
                        </Link>
                        {!(link?.currentPage) ? <p className="mx-2 text-sm">/</p> : null}
                    </React.Fragment>
                ))}
            </div>
            <div className="md:hidden flex justify-start align-center mb-2">
                {(() => {
                    let linkUrl = "https://sealskincovers.com/";
                    let linkTitle = "Home";

                    if (links?.length > 1) {
                        linkUrl = links.slice(-2, -1)[0]?.url;
                        linkTitle = links.slice(-2, -1)[0]?.title;
                    }

                    return (
                        <React.Fragment key={linkUrl}>
                            <Link className="text-sm flex font-normal" to={linkUrl}>
                                <p className="mr-2 text-sm">&lt;</p>
                                {linkTitle}
                            </Link>
                        </React.Fragment>
                    );
                })()}
            </div>
        </div>
    );
};

export default Breadcrumbs;
